import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { CarePlanTemplatesApi } from '../../../apis/CarePlanTemplatesApi/CarePlanTemplatesApi.ts';

export function useDeleteCarePlanTemplate() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, AppMedError, number>({
    mutationKey: [QueryKeys.carePlanTemplates, 'delete'],
    mutationFn: (id) => CarePlanTemplatesApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QueryKeys.carePlanTemplates],
      });
      notifications.show({
        color: 'teal',
        message: t('carePlan.notifications.deleted'),
      });
    },
    onError: (error) => {
      notifications.show({
        color: 'red',
        message: error?.message || t('carePlan.notifications.deleteError'),
      });
    },
  });
}
